






























import moment from 'moment-timezone';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { BaseVue } from '@/BaseVue';
import UiButton from '@/components/ui/UiButton.vue';
import UiDatePicker from '@/components/ui/UiDatePicker.vue';
import { getClusterAwareBaseUrl } from '@/utils/clusterAwareUrl';
import {
  CUSTOM_ACTIONS_REPORT_TYPE,
  CustomActionsReport as Report,
  defaultReportRunClient,
  describeFailedRun,
  describeRunError,
  ReportRunClient,
} from '@/utils/customActionsReports';

import { ApiSvcInventoryView } from '../../../../generated/api-svc';

@Component({ components: { UiButton, UiDatePicker } })
export default class CustomActionsReport extends BaseVue {
  @Prop({ required: true })
  public readonly view!: ApiSvcInventoryView | null;

  @Prop({ required: true })
  public readonly report!: Report;

  @Prop({ default: () => defaultReportRunClient })
  public readonly client!: ReportRunClient;

  public startDate = moment.tz(moment.tz.guess()).subtract(1, 'day').format('YYYY-MM-DD');
  public endDate = moment.tz(moment.tz.guess()).subtract(1, 'day').format('YYYY-MM-DD');
  public running = false;
  public error = '';
  private pollAborted = false;

  public baseUrl = getClusterAwareBaseUrl(process.env.VUE_APP_RPT_API_URL ?? process.env.VUE_APP_API_URL ?? '');

  beforeDestroy() {
    this.pollAborted = true;
  }

  async run() {
    const viewId = this.view?.id;
    if (!viewId || this.running) return;
    // Pin the org for submit → poll → download, as the other V3 reports do.
    const orgId = this.orgId;
    this.running = true;
    this.error = '';
    try {
      const runId = await this.client.submit(this.baseUrl, orgId, CUSTOM_ACTIONS_REPORT_TYPE, [
        { key: 'templateId', value: this.report.id },
        { key: 'inventoryViewId', value: viewId },
        { key: 'startDate', value: this.startDate },
        { key: 'endDate', value: this.endDate },
      ]);
      const { outcome, errors } = await this.client.poll(this.baseUrl, orgId, runId, {
        intervalMs: 3000,
        timeoutMs: 10 * 60 * 1000,
        isAborted: () => this.pollAborted,
      });
      if (outcome === 'aborted') return;
      if (outcome !== 'succeeded') {
        this.error =
          outcome === 'timed-out' ? 'The report timed out. Try a shorter date range.' : describeFailedRun(errors);
        return;
      }
      await this.client.download(this.baseUrl, orgId, runId, `${this.fileSlug}-${this.startDate}-${this.endDate}.csv`);
    } catch (err) {
      this.error = describeRunError(err);
    } finally {
      this.running = false;
    }
  }

  get fileSlug(): string {
    return (
      this.report.name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || 'custom-report'
    );
  }
}
